import { Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import React from "react"
import { tailwindPalette } from "../../../modules/theme/tailwindPalette"

const useStyles = makeStyles()(() => ({
    filtersCounter: {
        width: "1.25rem",
        height: "1.25rem",
        borderRadius: "100%",
        background: tailwindPalette.slate[900],
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        lineHeight: 1,
        color: "white",
        marginLeft: "0.5rem",
    },
}))

export function StandardFilterCounter({ show = true, counter }: { show?: boolean; counter: number }) {
    const { classes } = useStyles()

    if (!show) {
        return null
    }

    return (
        <Typography variant="subtitle2" className={classes.filtersCounter}>
            {counter}
        </Typography>
    )
}
